import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'

import { NewExpensePage } from '@/pages/expenses/new/NewExpensePage'

const NewExpenseSearchSchema = z.object({
  recurring: z.boolean().optional(),
  type: z.enum(['reimbursement']).optional(),
})

export const Route = createFileRoute('/_authenticated/_dashboard/expenses/new/')({
  validateSearch: NewExpenseSearchSchema,
  component: NewExpensePage,
})
